const updatePaymentMethods = (state, payload) => {
  state.paymentMethods = payload
}

const updateSubscriptions = (state, payload) => {
  state.subscriptions = payload
}

const setSubscription = (state, payload) => {
  state.subscription = payload
}

export default {
  updatePaymentMethods,
  updateSubscriptions,
  setSubscription,
}
